import { Options } from '../../Options'
import { ChartAxisConstants } from '../ChartAxis/ChartAxis.constants'

export const chartDataLabelOptions = Options.asRecord(
  Options.createOption({
    key: 'showDataLabels',
    inputKind: 'boolean',
    defaultValue: ChartAxisConstants.defaultShowDataLabels,
    label: 'Show data labels',
    description: 'Render measure values next to each data point.',
    category: 'Axis',
  }),
)

export type ChartDataLabelOptions = Options.TypeOf<typeof chartDataLabelOptions>
